module.exports = __webpack_public_path__ + "assets/amex-logo.b3f1ac33.svg";